import alt from '../alt';
import moment from 'moment';
import uuid from 'uuid';

import SingleObjectResource, {InvalidResponseCode}  from '../resources/GenericResource';

import CurrentUserActions from '../actions/CurrentUserActions';

import formatShiftTimes from '../utils/formatShiftTimes';

import NotificationActions from '../actions/NotificationActions';



class ShiftActions {
    constructor() {
        this.generateActions(
            'getSuccess', 'getFullReportSuccess', 'getDetailSuccess', 'saveStepOneData', 'saveStepTwoData', 'checkSuccess',
            'mergeErrorsIntoState', 'getDetailFailed', 'postUpdateToCandidatesSuccess', 'postUpdateToCandidatesError',
            'checkSuccess', 'saveDraftSucess', 'cancelSuccess', 'getUpdateRateSuccess', 'setCreateShiftDate',
            'getProSuccess', 'loadMoreProShifts', 'getMoreProShifts',
            'getShiftsToFinishSuccess', 'editError', 'getMaxRateSuccess', 'getLocationsSuccess', 'getMyShiftsSuccess',
            'getMyShiftsFailed', 'getMaxRateFailed', 'getProFailed', 'clearDetailShift', 'duplicateShift',
            'sendHiresListSuccess', 'sendHiresListError', 'clearHires', 'finishSuccess', 'optimisticShiftUpdate',
            'clearShifts', 'clearFinishedShifts', 'clearCreation'
        );
    }

    clearHires() {
        this.dispatch({});
    }

    createShift(stepOneData, stepTwoData, stepThreeData, stepChangeCallback, router) {
        const {startTime, endTime} = formatShiftTimes(stepOneData.start_date, stepOneData.start_time, stepOneData.end_time);
        const postData = {
            venue: stepOneData.venue,
            country: stepOneData.country,
            city: stepOneData.city,
            street: stepOneData.street,
            formatted_address: stepOneData.address,
            street_number: stepOneData.street_number,
            zip: stepOneData.zip,
            lat: stepOneData.lat,
            lng: stepOneData.lng,
            start_date: stepOneData.start_date,
            start_time: startTime.format("YYYY-MM-DDTHH:mm"),
            end_time: endTime.isBefore(startTime) ? endTime.add(1, 'd').format("YYYY-MM-DDTHH:mm") : endTime.format("YYYY-MM-DDTHH:mm"),
            description: stepOneData.description,
            contacts: stepOneData.contact_persons,
            status: "published",
            workers_needed: stepTwoData.workers_needed,
            rate: stepTwoData.rate,
            position_id: parseInt(stepTwoData.position),
            dresscode: stepTwoData.dresscode,
            payment_method_id: parseInt(stepThreeData.payment),
            payment_delivery_info: stepThreeData.paymentDescription,
            chat: stepThreeData.chat
        };

        new SingleObjectResource(DJ_CONST.API.shiftList).post(null, postData).then(result => {
            //Dispatch that we completed the save
            result.router = router;
            this.dispatch({result});
        }).catch(err => this.actions.failCreateShift(err, stepChangeCallback));
    }

    editShift(shiftId, formDataDetails, formDataPosition, formDataPayment, router) {
        const {startTime, endTime} = formatShiftTimes(formDataDetails.start_date, formDataDetails.start_time, formDataDetails.end_time);

        const postData = {
            venue: formDataDetails.venue,
            country: formDataDetails.country,
            city: formDataDetails.city,
            street: formDataDetails.street,
            formatted_address: formDataDetails.address,
            street_number: formDataDetails.street_number,
            zip: formDataDetails.zip,
            lat: formDataDetails.lat,
            lng: formDataDetails.lng,
            start_time: moment(startTime).format("YYYY-MM-DDTHH:mm"),
            end_time: endTime.isBefore(startTime) ? endTime.add(1, 'd').format("YYYY-MM-DDTHH:mm") : endTime.format("YYYY-MM-DDTHH:mm"),
            description: formDataDetails.description,
            contacts: formDataDetails.contact_persons || formDataDetails.contacts,
            workers_needed: formDataPosition.workers_needed,
            rate: formDataPosition.rate,
            position_id: parseInt(formDataPosition.position),
            dresscode: formDataPosition.dresscode,
            payment_method_id: parseInt(formDataPayment.payment),
            payment_delivery_info: formDataPayment.paymentDescription,
            chat: formDataPayment.chat
        };

        this.actions.optimisticShiftUpdate(postData.contacts);

        new SingleObjectResource(DJ_CONST.API.shiftEdit).post({pk: shiftId}, postData).then(result => {
            //Dispatch that we completed the save
            result.router = router;
            result.id = parseInt(shiftId);
            this.dispatch({result});
        }).catch(err => this.actions.failCreateShift(err, null));
    }

    saveDraft(formData, shiftId, router) {
        const {startTime, endTime} = formatShiftTimes(formData.start_date, formData.start_time, formData.end_time);

        let contact_persons = formData.contact_persons;
        if ( contact_persons.length === 1 && contact_persons[0]['name'] === "" && contact_persons[0]['phone'] == "" && contact_persons[0]['email'] == "") {
           contact_persons = [];
        }

        const postData = {
            venue: formData.venue || null,
            country: formData.country || '',
            city: formData.city || '',
            formatted_address: formData.address,
            street_number: formData.street_number,
            zip: formData.zip || '',
            lat: formData.lat || null,
            lng: formData.lng || null,
            start_time: moment(startTime).format("YYYY-MM-DDTHH:mm"),
            end_time: endTime.isBefore(startTime) ? endTime.add(1, 'd').format("YYYY-MM-DDTHH:mm") : endTime.format("YYYY-MM-DDTHH:mm"),
            description: formData.description || "",
            workers_needed: formData.workers_needed || null,
            rate: formData.rate || null,
            contacts: contact_persons || null,
            position_id: parseInt(formData.position) || null,
            dresscode: formData.dresscode || null,
            payment_method_id: parseInt(formData.payment) || null,
            payment_delivery_info: formData.paymentDescription || null,
            status: formData.status || 'draft',
            chat: !!formData.chat
        };
        const shiftPk = typeof shiftId === 'undefined' ? 0 : shiftId;
        new SingleObjectResource(DJ_CONST.API.shiftSaveDraft).post({pk: shiftPk}, postData).then(result => {
            //Dispatch that we completed the save
            result.router = router;
            this.dispatch({result});
        }).catch(err => this.actions.failCreateShift(err, null));
    }

    failCreateShift(updateError, stepChangeCallback) {
        if ( typeof updateError === 'undefined') {
            this.dispatch({});
        } else {
            if (updateError.statusCode === 400 || updateError.statusCode === 403){
                const jsonErr = JSON.parse(updateError.responseText);

                if (jsonErr && jsonErr.detail) {
                    NotificationActions.showError(`Hiring:Error:${uuid.v4()}`, jsonErr.detail);
                }

                this.dispatch({updateError, stepChangeCallback});
            } else {
                return CurrentUserActions.pageFault(updateError);
            }
        }
    }
}

export default alt.createActions(ShiftActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/ShiftActions.js
 **/